import React from "react";
import { Link } from "react-router-dom";
import AmgPage from "./AmgPage";
import googlePlayBadge from "./badges/google-play-badge.png";
import appStoreBadge from "./badges/app-store-badge.svg";
import { GAMES, useCampaign, playHref, appStoreHref } from "./storeLinks";

export default function AirplaneModeGamesPage() {
  const campaign = useCampaign();
  return (
    <AmgPage title="No internet. No problem.">
      <p>
        Airplane Mode Games are multiplayer games for the places the
        internet can't reach — a row on a flight, a subway car, a campsite,
        a cabin. The phones in the room find each other over Bluetooth and
        the whole game runs right there at the table.
      </p>
      <h2>The games</h2>
      <div className="amg-game">
        <div className="amg-game-title">Airplane Mode Poker</div>
        <p>
          Texas Hold'em for 2–6 players. Cards are dealt over Bluetooth
          between the phones at the table. Play money only. Free to join a
          table; hosting is a one-time purchase.
        </p>
        <div className="amg-badges">
          <a
            href={playHref(GAMES.poker.packageName, campaign)}
            aria-label="Get Airplane Mode Poker on Google Play"
          >
            <img src={googlePlayBadge} alt="Get it on Google Play" />
          </a>
          <a
            href={appStoreHref(GAMES.poker.appleId, campaign)}
            aria-label="Download Airplane Mode Poker on the App Store"
          >
            <img src={appStoreBadge} alt="Download on the App Store" />
          </a>
        </div>
        {/* Required by ad-platform social-casino policies (e.g. Google's
            certification): the ads' landing page must carry this
            adult-audience disclaimer. Keep it visible and verbatim-ish. */}
        <p className="amg-effective">
          Airplane Mode Poker is intended for an adult audience (18+). It
          does not offer real-money gambling or an opportunity to win real
          money or prizes. Practice or success at social casino gaming does
          not imply future success at real-money gambling.
        </p>
      </div>
      <div className="amg-game">
        <div className="amg-game-title">Airplane Mode Liar's Dice</div>
        <p>
          Liar's dice for 2–6 players. Everyone shakes a cup of dice, bids
          climb around the table, and sooner or later somebody calls
          LIAR! and the cups come off. No money, real or pretend. Free to
          join a table; hosting is a one-time purchase.
        </p>
        <div className="amg-badges">
          <a
            href={playHref(GAMES["liars-dice"].packageName, campaign)}
            aria-label="Get Airplane Mode Liar's Dice on Google Play"
          >
            <img src={googlePlayBadge} alt="Get it on Google Play" />
          </a>
          <a
            href={appStoreHref(GAMES["liars-dice"].appleId, campaign)}
            aria-label="Download Airplane Mode Liar's Dice on the App Store"
          >
            <img src={appStoreBadge} alt="Download on the App Store" />
          </a>
        </div>
      </div>
      <div className="amg-game">
        <div className="amg-game-title">Airplane Mode Classic Board Games</div>
        <p>
          Chess, checkers, and backgammon for two players, all in one app.
          Play phone to phone over Bluetooth, or pass one phone back and
          forth across the tray table. Joining a table and pass &amp; play
          are always free; hosting is one purchase for all three games, and
          your first hosted game is on us.
        </p>
        <div className="amg-badges">
          <a
            href={playHref(GAMES["board-games"].packageName, campaign)}
            aria-label="Get Airplane Mode Classic Board Games on Google Play"
          >
            <img src={googlePlayBadge} alt="Get it on Google Play" />
          </a>
          {GAMES["board-games"].appleId && (
            <a
              href={appStoreHref(GAMES["board-games"].appleId, campaign)}
              aria-label="Download Airplane Mode Classic Board Games on the App Store"
            >
              <img src={appStoreBadge} alt="Download on the App Store" />
            </a>
          )}
        </div>
        {!GAMES["board-games"].appleId && (
          <p className="amg-effective">Coming soon to the App Store.</p>
        )}
      </div>
      <p>More games are on the way.</p>
      <h2>Privacy</h2>
      <p>
        Every Airplane Mode game runs entirely on the devices at your
        table, so one short{" "}
        <Link to="/airplane-mode-games/privacy">privacy policy</Link> covers
        them all: we collect no personal data.
      </p>
      <h2>Open-source licenses</h2>
      <p>
        The games ship with open-source software: Kotlin and kotlinx
        libraries (JetBrains, Apache 2.0), Compose Multiplatform and Skiko
        (JetBrains, Apache 2.0), Jetpack Compose and AndroidX (The Android
        Open Source Project, Apache 2.0), the Skia graphics engine
        (Google, BSD 3-Clause), and the Upheaval TT pixel font (Brian
        Kent/ÆNIGMA, freeware). Full license texts are embedded in each app
        under Settings → Open-source licenses.
      </p>
      <h2>Contact</h2>
      <p>
        Questions, bugs, or ideas: <strong>help@testco.de</strong>
      </p>
    </AmgPage>
  );
}
